import type { ReactElement } from 'react';
import App from './App';
import Index from './pages/Index';
import Team from './pages/Team';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Booking from './pages/Booking';
import DietitianSandton from './pages/DietitianSandton';
import DietitianGlenhazel from './pages/DietitianGlenhazel';
import DietitianRandburg from './pages/DietitianRandburg';
import DietitianFourways from './pages/DietitianFourways';
import DietitianRosebank from './pages/DietitianRosebank';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import { BLOG_POSTS } from './data/blogPosts';

type RouteRecord = {
  path?: string;
  index?: boolean;
  element: ReactElement;
  children?: RouteRecord[];
};

export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Index /> },
      { path: 'team', element: <Team /> },
      { path: 'services', element: <Services /> },
      { path: 'services/nutrition-counselling', element: <Services /> },
      { path: 'services/gut-health', element: <Services /> },
      { path: 'services/weight-management', element: <Services /> },
      { path: 'services/sports-nutrition', element: <Services /> },
      { path: 'services/chronic-diseases', element: <Services /> },
      { path: 'services/lifecycle-nutrition', element: <Services /> },
      { path: 'contact', element: <Contact /> },
      { path: 'booking', element: <Booking /> },
      { path: 'dietitian-sandton', element: <DietitianSandton /> },
      { path: 'dietitian-glenhazel', element: <DietitianGlenhazel /> },
      { path: 'dietitian-randburg', element: <DietitianRandburg /> },
      { path: 'dietitian-fourways', element: <DietitianFourways /> },
      { path: 'dietitian-rosebank', element: <DietitianRosebank /> },
      { path: 'blog', element: <Blog /> },
      {
        path: 'blog/:slug',
        element: <BlogPost />,
      },
    ],
  },
];